<template>
  <DefaultSection class="banner">
    <Container>
      <div class="inner has-text-white has-background-bright-gray-blue">
        <div class="status-icons has-text-centered">
          <img
            alt="Status"
            src="~/assets/svgs/statuses.svg?url"
            data-not-lazy
          />
        </div>
        <div class="columns is-vcentered has-text-centered-mobile">
          <div class="column is-3 is-offset-1">
            <MediaSvgIcon v-if="svgIcon" v-bind="svgIcon" class="svg-icon" />
          </div>
          <div class="column is-7">
            <h2 class="title is-size-banner has-text-white text-shadow">
              {{ title }}
            </h2>
            <p class="has-text-weight-semibold is-size-normal text-shadow">
              {{ lead }}
            </p>
          </div>
        </div>
      </div>
    </Container>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphIconBannerFragment } from '#graphql-operations'

defineProps<ParagraphIconBannerFragment>()

defineBlokkli({
  bundle: 'icon_banner',
})
</script>

<style scoped lang="scss">
.banner {
  padding-top: toRem(60);
  padding-bottom: toRem(60);
  @include tablet {
    padding-top: toRem(80);
    padding-bottom: toRem(80);
  }
}
.inner {
  box-shadow: 0 12px 32px -8px rgba(26, 26, 26, 0.6);

  padding-top: toRem(60);
  padding-bottom: toRem(60);
  margin-top: toRem(0);
  margin-bottom: toRem(0);

  padding-right: toRem(60);
  padding-left: toRem(60);

  border-radius: 10px;
  @include desktop {
    margin: 0 95px;
  }

  @include mobile {
    padding-top: toRem(30);
    padding-bottom: toRem(40);
    padding-right: toRem(30);
    padding-left: toRem(30);
    .svg-icon {
      margin: 0 auto -2rem auto;
      max-width: 120px;
    }
  }
}

.status-icons {
  position: relative;
  height: 0;
  top: toRem(-73);

  img {
    max-height: 15px;
  }

  @include tablet {
    top: toRem(-70);
    img {
      max-height: 30px;
    }
  }

  @include mobile {
    top: toRem(-40);
  }
}

.text-shadow {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
